<template>
    <div class="d-flex flex-column gap-10">
        <div>
            <div class="font-size-h2 mb-2">
                {{ __('general.preview') }}
            </div>
            <Alert type="secondary" :title="__('offers.widget.preview_notice')">
                <template v-slot:icon>
                    <i class="fas fa-exclamation-circle"/>
                </template>
                <ul>
                    <li>{{ __('offers.widget.preview_notice_items.0') }}</li>
                    <li>{{ __('offers.widget.preview_notice_items.1') }}</li>
                    <li>{{ __('offers.widget.preview_notice_items.2') }}</li>
                </ul>
            </Alert>
        </div>

        <FormGroupNew :label="__('offers.widget.embed_code')"
                      :description="__('offers.widget.copy_and_embed')"
                      no-margin
                      required
        >
            <div class="border rounded p-3 bg-light-light">
                    <textarea ref="code"
                              class="w-100 border-0 bg-transparent text-dark"
                              type="text"
                              v-html="code"
                              readonly
                              style="outline: none;"
                              @click="selectCode"
                    />
            </div>

            <div class="btn-group w-100 mt-2">
                <button class="btn btn-info" @click="openPreview" :class="{'disabled': preview != null}">
                    <i class="fas fa-eye"/>
                    {{ __('actions.show_thing', {thing: __('general.preview')}) }}
                </button>
                <button class="btn btn-secondary" @click="copyCode">
                    <i class="fas fa-copy"/>
                    {{ __('actions.copy_thing', {thing: __('offers.widget.embed_code')}) }}
                </button>
            </div>
        </FormGroupNew>
    </div>
</template>

<script>
import {debounce} from "@composables/debounce";
import Alert from "@components/Alert.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew, Alert},

    props: {
        offer: Object,
        settings: Object,
        mixFile: String,
        encodedStoreUuid: String,
    },

    data() {
        return {
            preview: null,
            previewSizes: {
                'slider': `width=${window.screen.availWidth * 0.6},height=400`,
                'grid': `width=${window.screen.availWidth * 0.4},height=${window.screen.availHeight * 0.4}`,
            },
        }
    },

    beforeMount() {
        window.onbeforeunload = this.closePreview
    },

    mounted() {
        this.adjustTextareaToContentSize();
    },

    methods: {
        openPreview() {
            if (!this.preview) {
                this.preview = window.open(
                    '',
                    'preview',
                    `left=50,top=50,${this.previewSizes[this.settings.type]},toolbar=0,scrollbars=0,status=0`,
                )

                let timer = setInterval(() => {
                    if (this.preview.closed) {
                        clearInterval(timer)
                        this.preview = null
                    }
                }, 100)

                this.updatePreview();
            } else {
                this.preview.focus()
            }
        },

        adjustTextareaToContentSize() {
            this.$refs.code.style.height = this.$refs.code.scrollHeight + 'px'
        },

        updatePreview() {
            if (this.preview) {
                this.preview.document.write(this.titleElement + this.code)
                this.preview.document.close()
            }
        },

        closePreview() {
            if (this.preview) {
                this.preview.close()
                this.preview = null
            }
        },

        selectCode() {
            this.$refs.code.select()
        },

        copyCode() {
            navigator.clipboard.writeText(this.code)
        },
    },

    computed: {
        targetDivId() {
            return 'ybd' + Date.now()
        },

        baseUrl() {
            const {hostname} = new URL(this.$dreamlifterApi())
            return `${location.protocol}//${hostname}`
        },

        scriptUrl() {
            return `${this.baseUrl}/${this.mixFile}?t=${this.targetDivId}&c=${this.configString}`
        },

        titleElement() {
            return `<title>Widget Vorschau: ${this.settings.type.ucfirst()} (${this.offer.name})<\/title>`
        },

        code() {
            return `<div id="${this.targetDivId}"><\/div><script src="${this.scriptUrl}"><\/script>`
        },

        configString() {
            return btoa(JSON.stringify({
                store: this.encodedStoreUuid,
                offer: this.offer.id,
                settings: this.settings,
            }))
        },
    },

    watch: {
        settings: {
            deep: true,
            handler: debounce(function (newValue, oldValue) {
                this.adjustTextareaToContentSize();
                this.updatePreview()
            }, 200),
        },
    },
}
</script>
